import { metaToConsts } from "@/shared/lib/meta-to-consts";
import type { ValueMeta } from "@/shared/model";

/* ── Auth ── */
export const AUTH_ROUTE_META = [
  { id: "AR01", name: "LOGIN", label: "로그인", value: "/auth/login" },
  { id: "AR02", name: "SIGNUP", label: "회원가입", value: "/auth/signup" },
] as const satisfies readonly ValueMeta<string>[];

/* ── Main ── */
export const MAIN_ROUTE_META = [
  { id: "MR01", name: "HOME", label: "홈", value: "/" },
  { id: "MR02", name: "DASHBOARD", label: "대시보드", value: "/dashboard" },
] as const satisfies readonly ValueMeta<string>[];

/* ── Chat ── */
export const CHAT_ROUTE_META = [
  { id: "CR01", name: "CHAT", label: "대화", value: "/chat" },
  { id: "CR02", name: "CHAT_COMPLETE", label: "대화 완료", value: "/chat/complete" },
] as const satisfies readonly ValueMeta<string>[];

/* ── Scenario ── */
export const SCENARIO_ROUTE_META = [
  { id: "SR01", name: "SCENARIO_SELECT", label: "시나리오 선택", value: "/scenario-select" },
  {
    id: "SR02",
    name: "DIRECT_SPEECH",
    label: "직접 발화",
    value: "/scenario-select/direct-speech",
  },
  {
    id: "SR03",
    name: "SUBTITLE_SETTINGS",
    label: "자막 설정",
    value: "/scenario-select/subtitle-settings",
  },
  {
    id: "SR04",
    name: "VOICE_SELECTION",
    label: "음성 선택",
    value: "/scenario-select/voice-selection",
  },
] as const satisfies readonly ValueMeta<string>[];

export const AUTH_ROUTE_VALUE = metaToConsts(AUTH_ROUTE_META);
export const MAIN_ROUTE_VALUE = metaToConsts(MAIN_ROUTE_META);
export const CHAT_ROUTE_VALUE = metaToConsts(CHAT_ROUTE_META);
export const SCENARIO_ROUTE_VALUE = metaToConsts(SCENARIO_ROUTE_META);
